<template>
<div class='recharge'>
    <Head :goBack='true' show="" title="支付成功抽奖"></Head>
    <div class="recharge_kong">&nbsp;</div>
    <div class='recharge_title'>
      幸运抽大奖<br>
      好礼赢不停
    </div>
    <div class='recharge_subtitle'>
      666元大礼包等你来拿
    </div>
    <div class="recharge_wheel">
      <LuckyGrid
        ref="LuckyWheel"
        class="luck-box"
        :blocks="blocks"
        :prizes="prizes"
        :buttons="buttons"
        :activeStyle="activeStyle"
        @start="startCallBack"
        @end="endCallBack"
      />
    </div>
    <div class="recharge_chance">今日还剩
      <span>{{limitParticipate.dayLimit}}</span>
      次抽奖机会</div>
    <div class="recharge_coupon">我的优惠券>></div>
    <receive-award-modal ref="receiveAwardModal" />
  </div>
</template>

<script>
import { Toast } from "vant";
import ReceiveAwardModal from "@/components/ReceiveAwardModal";
export default {
  components: {
    ReceiveAwardModal
  },
  name: "Lottery",
  data() {
    return {
      activeStyle: {
        background: "#eb2f14",
        fontColor:'#fff'
      },
      blocks: [
        { padding: "1px", background: "rgba(255, 255, 255, 0)" },
        { padding: "0px", background: "rgba(255, 255, 255, 0)" },
      ],
      prizes: [
        {
          x: 0,
          y: 0,
          fonts: [{ text: "谢谢参与", top: "36%" ,fontSize:'15px'}],
          background: "rgba(255, 255, 255, 0)",
        },
        {
          x: 1,
          y: 0,
          fonts: [{ text: "谢谢参与", top: "36%" ,fontSize:'15px'}],
          background: "rgba(255, 255, 255, 0)",
        },
        {
          x: 2,
          y: 0,
          fonts: [{ text: "谢谢参与", top: "36%",fontSize:'15px' }],
          background: "rgba(255, 255, 255, 0)",
        },
        {
          x: 2,
          y: 1,
          fonts: [{ text: "谢谢参与", top: "36%",fontSize:'15px' }],
          background: "rgba(255, 255, 255, 0)",
        },
        {
          x: 2,
          y: 2,
          fonts: [{ text: "谢谢参与", top: "36%",fontSize:'15px' }],
          background: "rgba(255, 255, 255, 0)",
        },
        {
          x: 1,
          y: 2,
          fonts: [{ text: "谢谢参与", top: "36%",fontSize:'15px' }],
          background: "rgba(255, 255, 255, 0)",
        },
        {
          x: 0,
          y: 2,
          fonts: [{ text: "谢谢参与", top: "36%",fontSize:'15px' }],
          background: "rgba(255, 255, 255, 0)",
        },
        {
          x: 0,
          y: 1,
          fonts: [{ text: "谢谢参与", top: "36%" ,fontSize:'15px'}],
          background: "rgba(255, 255, 255, 0)",
        },
      ],
      buttons: [
        {
          x: 1,
          y: 1,
          background: "rgba(255, 255, 255, 0)",
          fonts: [{ text: " ", top: "40%" }],
        },
      ],
      queryData: {},
      limitParticipate: {
        dayLimit:0
      },
      tyArr: [],
      dataList:[],
      activeData:[]
    };
  },
  mounted() {
    let orderNo = this.$route.query.orderNo;
    if (orderNo) {
      this.queryData =  this.$route.query
      this.getPrizesList();
    } else {
      // this.$router.push({ name: 'home' })
    }
  },
  methods: {
    getPrizesList() {
      const params={
        deviceNum: this.deviceNum,
        activityId: this.queryData.activityId,
      }
      this.$api.coupon.getActivityCoupons(params).then(res => {
        if (res.code == 200) {
          if (res.coupons && (res.coupons.length === this.prizes.length)) {
              this.dataList = res.coupons
              this.tyArr = []
              res.coupons.forEach((item,i)=>{
                this.prizes[i].fonts[0].text = item ? item.name : '谢谢惠顾'
                if (!(item&&item.name)) {
                  this.tyArr.push(i)
                }
              })
              this.limitParticipate.dayLimit = res.limitParticipate&& res.limitParticipate.dayLimit?'1':0
          } else {
            this.tyArr = [0]
            Toast('抽奖活动异常！')
          }
        } else {
          this.tyArr = [0]
          Toast(res.msg)
        }
      })
    },
    getRandomElement(array) {
      if (array.length === 0) {
        return null;
      }
      const randomIndex = Math.floor(Math.random() * array.length);
      return array[randomIndex];
    },
    // 查询活动
    getActivity() {
      const params={
        orderNo:this.queryData.orderNo,
        deviceNum: this.deviceNum,
        activityId: this.queryData.activityId,
        activityType: this.queryData.activityType,
      }
      this.$api.coupon.getActivity(params).then(res => {
        var index = 3;
        if (res.code == 200) {
            if (res.result && res.result.length>0) {
              this.dataList.forEach((item, i) => {
                if (item&&(item.name == res.result[0].name)) {
                  index = i
                }
              })
              this.activeData= res.result
            } else {
              index = this.getRandomElement(this.tyArr)
            }
          } else {
            index = this.getRandomElement(this.tyArr)
          }
          console.log(index,'index')
        this.$refs.LuckyWheel.stop(index);
      }).catch(() => {
        this.$refs.LuckyWheel.stop(this.getRandomElement(this.tyArr));
      })
    },
    // 点击抽奖按钮会触发star回调
    startCallBack() {
      if (!this.limitParticipate.dayLimit) {
        Toast('抽奖机会已用完')
        return 
      }
      // 调用抽奖组件的play方法开始游戏
      this.limitParticipate.dayLimit = this.limitParticipate.dayLimit - 1
      this.$refs.LuckyWheel.play();
      this.getActivity()
    },
    endCallBack(prize) {
      if(prize.fonts[0].text!='谢谢参与'&&prize.fonts[0].text!='谢谢惠顾'){
          this.$refs.receiveAwardModal.title = '抽奖成功'
          console.log(this.activeData,'this.activeData')
        this.$refs.receiveAwardModal.showModal(this.activeData)
      }else{
        alert(`${prize.fonts[0].text}`);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.recharge_kong{
  width: 100%;
  height: 100px;
}
.recharge{
  height: calc(100vh );
  background: url('~@/assets/images/lottery.png') no-repeat center center;
  background-size:100% 100% ;
  .recharge_title{
    width: 100%;
    text-align: center;
    height: 24vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 64px;
    color: #f7f7f7;
    font-weight: 600;
    text-shadow: 4px 4px 5px rgba(2,144,130,.6);
  }
  .recharge_subtitle{
    width: 100%;
    height: 3.3vh;
    line-height: 3.3vh;
    padding-top: 16.5vh;
    color: #fff5eb;
    font-size: 30px;
    text-align: center;
  
  }
  .recharge_wheel{
    display: flex;
    justify-content: center;
    padding-top: 3.7vh;
  }
  .luck-box{
    width: 78.4vw;
    height: 32vh;
  }
  .recharge_chance{
    color: #cfe8e2;
    font-size: 22px;
    text-align: center;
    height: 4vh;
    line-height: 4vh;
    span{
      color: #fccd49;
    }
  } 
  .recharge_coupon{
    color: #cceae2;
    font-size: 26px;
    height: 5vh;
    line-height: 5vh;
    text-align: center;
  }
  // background-color: #f7f7f7;
}

</style>
